import { render, staticRenderFns } from "./yc-annals-target-details.vue?vue&type=template&id=182ab9e9&scoped=true&"
import script from "./yc-annals-target-details.vue?vue&type=script&lang=js&"
export * from "./yc-annals-target-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182ab9e9",
  null
  
)

export default component.exports